<br>
<div class="ms-2">
  <div class="col-sm-12 border" style="padding: 20px;">
    <form *ngIf="!hidecontent" [formGroup]="institutionform">
      <div class="row" style="border-bottom: 1px solid #F0F0F0;">
        <div class="form-group col-md-4">
          <p>Hantera medlemsavgifter för</p>
          <span style="font-size: 22px;font-weight: bold;">{{currentinstitution?.shortName}} {{currentinstitution?.name}}</span>
        </div>
        <div class="form-group col-md-6">
          <div *ngIf="institutionform.valid">
            <div class="form-group">
              <label for="actioncontrol">Välj åtgärd</label>
              <select class="form-control form-control-sm" id="actioncontrol" (change)="setAction($event)">
                <option></option>
                <option value="registerPayments">Registrera inbetalning för {{currentinstitution?.shortName}} {{currentinstitution?.name}}</option>
                <option value="nedsattning">Nedsättning av medlemsavgift {{currentinstitution?.shortName}} {{currentinstitution?.name}}</option>
                <option value="handleFees">Hantera avgifter för {{currentinstitution?.shortName}} {{currentinstitution?.name}}</option>
              </select>
            </div>
          </div>
        </div>
        <div *ngIf="viewyear" class="form-group col-md-2">
          <label for="year">Välj år</label>
          <select class="form-control form-control-sm" id="year" formControlName="year" (change)="setYear($event)" style="max-width:120px;" required>
            <option></option>
            <option *ngFor="let y of years" [value]="y">{{y}}</option>
          </select>
        </div>
      </div>
    </form>
    <br>
    <div *ngIf="link==='handleFees'" class="row">
      <div class="col-md-12">
        <app-handlefees [institution]=currentinstitution [year]=selectedyear></app-handlefees>
      </div>
    </div>
    <div *ngIf="link==='registerPayments'" class="row">
      <app-registerpayments [institution]=currentinstitution [year]=selectedyear (doMail)="hideContent($event)"></app-registerpayments>
    </div>
    <div *ngIf="link==='nedsattning'" class="row">
      <div class="col-md-12">
        <app-nedsattning [institution]=currentinstitution [year]=selectedyear></app-nedsattning>
      </div>
    </div>
  </div>
</div>